var map = {
	"./dissatisfied.svg": 8054,
	"./icons.svg": 2511,
	"./meter-read-bottom-line.png": 2226,
	"./meter-read-top-line.png": 661,
	"./neither.svg": 7746,
	"./ripple-mask.svg": 9613,
	"./satisfied.svg": 7529,
	"./very-dissatisfied.svg": 2655,
	"./very-satisfied.svg": 4280,
	"./wave-icon.png": 3739
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;